<template>
  <div ref="dropdownRef" :class="$style.dropdownWrapper" :style="dynamicStyles">
    <div>
      <slot name="header"></slot>
      <SCADivider appearance="border" :class="$style.divider"></SCADivider>
    </div>
    <div :class="$style.dropdownContent">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SCADivider } from "@scayla/components";
import { computed, onMounted, ref } from "vue";

const DROPDOWN_MIN_HEIGHT = 366;

const dropdownRef = ref<HTMLElement | null>(null);
const maxHeight = ref<number>(DROPDOWN_MIN_HEIGHT);

const dynamicStyles = computed(() => ({
  maxHeight: `${maxHeight.value}px`,
}));

const calculateMaxHeight = () => {
  if (!dropdownRef.value) return;

  const rect = dropdownRef.value.getBoundingClientRect();
  const viewportHeight = window.innerHeight;

  const padding = 8;
  const availableHeight = viewportHeight - rect.top - padding * 3;

  maxHeight.value = Math.max(DROPDOWN_MIN_HEIGHT, availableHeight);
};

onMounted(() => {
  calculateMaxHeight();
});
</script>

<style lang="scss" module>
.dropdownWrapper {
  display: flex;
  flex-direction: column;
  width: 232px;
  padding: 0 var(--space-component-padding-xSmall);
}

.dropdownContent {
  display: flex;
  padding-top: var(--space-component-padding-small);
  flex-direction: column;
  width: 100%;
  overflow: auto;
}

.divider {
  margin: calc(var(--space-component-padding-small) - 1px) calc(var(--space-component-padding-medium) * (-1)) 0;
}
</style>
